// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item-name {
  font-family: AppFontMedium;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: -0.02em;
  text-transform: uppercase;
  padding-bottom: 4px;
  margin-bottom: 8px;
}

@media (min-width: 991px) {
  .item-image {
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    background: transparent;
    padding: 18px 0;
    border: 0;
    height: 160px;
  }
}

.info {
  margin: 0;
  flex: 1;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: AppFont;
  font-size: 12px;
  line-height: 17.55px;
  color: var(--color-grey);
  margin-bottom: 4px;
}

.info-text {
  flex: 1;
}

.action-icon {
  width: 29px;
  height: 29px;
  margin-left: 25px;
}
@media (min-width: 991px) {
  .action-icon {
    display: none;
  }
}

.price-col {
  display: flex;
  flex-direction: column;
}

.price {
  margin: 0;
  font-family: AppFontMedium;
  font-size: 16px;
  line-height: 19px;
  text-align: right;
  margin-bottom: 8px;
  color: var(--color-grey);
}

.add-product-icon {
  height: 32px;
  width: 32px;
  margin-top: auto;
  margin-left: auto;
  margin-bottom: 17px;
}

.item-row {
  margin-bottom: 20px;
  padding: 0px;
  height: 100%;
  min-height: 90px;
}
@media (min-width: 991px) {
  .item-row {
    background: transparent;
    border-radius: 0;
    cursor: pointer;
    height: 100%;
    border: 1.5px solid transparent;
    transition: border 0.2s ease;
  }
  .item-row ion-img {
    height: 100%;
  }
}

.item-info {
  padding: 0;
  padding-right: 8px;
  padding-left: 8px;
  height: 83%;
}
@media (min-width: 991px) {
  .item-info {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
}

app-tag {
  margin-left: 3px;
}

.lines-col {
  padding: 0;
  padding-bottom: 5px;
}
@media (min-width: 991px) {
  .lines-col {
    height: min-content;
    margin-top: auto;
  }
}

.first-line {
  display: block;
  height: 0.5px;
  width: 100%;
  margin: 0px 0px 0px 0px;
  opacity: 0.5;
  content: "";
  background: #939393;
}

.second-line {
  display: block;
  height: 1px;
  width: 100%;
  margin: 5px 0px;
  content: "";
  background: #939393;
}

.add-btn {
  width: 25px;
  height: 25px;
  background: var(--ion-color-secondary);
  color: #ffffff;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  margin: 0px 0px 0px 5px;
}
@media (min-width: 991px) {
  .add-btn {
    display: none;
  }
}

.pfand-meirnveg {
  margin: 0;
  font-size: 12px;
}

.item-img {
  padding: 0;
}
@media (min-width: 991px) {
  .item-img {
    display: block;
  }
}

.image-wrapper {
  position: relative;
  width: 100%;
}
@media (min-width: 991px) {
  .image-wrapper {
    padding: 0px;
    border-radius: 2px;
  }
}
.image-wrapper .main-img {
  border-radius: 1px;
  overflow: hidden;
  object-fit: contain;
  width: 100%;
  aspect-ratio: 4/3;
}
.image-wrapper .main-img.default {
  height: 100%;
  width: 85%;
  background-color: #fff;
  --logo-color: var(--ion-color-primary);
}

.top-selling {
  position: absolute;
  top: 2px;
  left: 50%;
  transform: translateX(-50%);
  height: 25px;
  width: 25px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/item-view/item-view.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EAEA,yBAAA;EAEA,mBAAA;EACA,kBAAA;AAHD;;ACPE;EDcF;IAEE,sBAAA;IACA,aAAA;IACA,uBAAA;IACA,mBAAA;IACA,uBAAA;IACA,eAAA;IACA,SAAA;IACA,aAAA;EAJA;AACF;;AAOA;EACC,SAAA;EACA,OAAA;EACA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,eAAA;EACA,oBAAA;EAGA,wBAAA;EAEA,kBAAA;AAPD;;AASA;EACC,OAAA;AAND;;AASA;EACC,WAAA;EACA,YAAA;EACA,iBAAA;AAND;AC9CE;EDiDF;IAKE,aAAA;EAJA;AACF;;AAOA;EACC,aAAA;EACA,sBAAA;AAJD;;AAOA;EACC,SAAA;EAEA,0BAAA;EACA,eAAA;EACA,iBAAA;EAEA,iBAAA;EACA,kBAAA;EACA,wBAAA;AAND;;AAeA;EACC,YAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AAZD;;AAeA;EACC,mBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;AAZD;ACjFE;EDyFF;IAOE,uBAAA;IACA,gBAAA;IACA,eAAA;IACA,YAAA;IACA,+BAAA;IACA,4BAAA;EAXA;EAiBA;IACC,YAAA;EAfD;AACF;;AAmBA;EACC,UAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;AAhBD;ACrGE;EDiHF;IAOE,aAAA;IACA,sBAAA;IACA,2BAAA;EAfA;AACF;;AAkBA;EACC,gBAAA;AAfD;;AAkBA;EACC,UAAA;EACA,mBAAA;AAfD;ACrHE;EDkIF;IAKE,mBAAA;IACA,gBAAA;EAdA;AACF;;AAiBA;EACC,cAAA;EACA,aAAA;EACA,WAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;AAdD;;AAgBA;EACC,cAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;AAbD;;AAeA;EACC,WAAA;EACA,YAAA;EACA,sCAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,uBAAA;AAZD;AC3JE;ED6JF;IAYE,aAAA;EAVA;AACF;;AAaA;EACC,SAAA;EACA,eAAA;AAVD;;AAaA;EACC,UAAA;AAVD;ACzKE;EDkLF;IAGE,cAAA;EARA;AACF;;AAWA;EACC,kBAAA;EAIA,WAAA;AAXD;ACnLE;EDyLF;IASE,YAAA;IACA,kBAAA;EAXA;AACF;AAaC;EACC,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;AAXF;AAaE;EACC,YAAA;EACA,UAAA;EAEA,sBAAA;EACA,sCAAA;AAZH;;AAiBA;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,2BAAA;EACA,YAAA;EACA,WAAA;AAdD","sourcesContent":["@use '../../../theme/mixins' as *;\n\n.item-name {\n\tfont-family: AppFontMedium;\n\tfont-size: 16px;\n\tline-height: 19px;\n\tletter-spacing: -0.02em;\n\n\ttext-transform: uppercase;\n\n\tpadding-bottom: 4px;\n\tmargin-bottom: 8px;\n\t// border-bottom: 1px solid var(--ion-color-primary);\n}\n\n.item-image {\n\t@include desktop {\n\t\tbox-sizing: border-box;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tbackground: transparent;\n\t\tpadding: 18px 0;\n\t\tborder: 0;\n\t\theight: 160px;\n\t}\n}\n\n.info {\n\tmargin: 0;\n\tflex: 1;\n\tword-break: break-word;\n\tdisplay: -webkit-box;\n\t-webkit-line-clamp: 3;\n\t-webkit-box-orient: vertical;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\tfont-family: AppFont;\n\tfont-size: 12px;\n\tline-height: 17.55px;\n\t// letter-spacing: -0.01em;\n\n\tcolor: var(--color-grey);\n\n\tmargin-bottom: 4px;\n}\n.info-text {\n\tflex: 1;\n}\n\n.action-icon {\n\twidth: 29px;\n\theight: 29px;\n\tmargin-left: 25px;\n\t@include desktop {\n\t\tdisplay: none;\n\t}\n}\n\n.price-col {\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.price {\n\tmargin: 0;\n\n\tfont-family: AppFontMedium;\n\tfont-size: 16px;\n\tline-height: 19px;\n\t// letter-spacing: 0.02em;\n\ttext-align: right;\n\tmargin-bottom: 8px;\n\tcolor: var(--color-grey);\n\t// text-transform: uppercase;\n\n\t// @include desktop {\n\t//   // padding: 20px 12px;\n\t//   text-align: left;\n\t// }\n}\n\n.add-product-icon {\n\theight: 32px;\n\twidth: 32px;\n\tmargin-top: auto;\n\tmargin-left: auto;\n\tmargin-bottom: 17px;\n}\n\n.item-row {\n\tmargin-bottom: 20px;\n\tpadding: 0px;\n\theight: 100%;\n\tmin-height: 90px;\n\n\t@include desktop {\n\t\tbackground: transparent;\n\t\tborder-radius: 0;\n\t\tcursor: pointer;\n\t\theight: 100%;\n\t\tborder: 1.5px solid transparent;\n\t\ttransition: border 0.2s ease;\n\n\t\t// &:hover {\n\t\t// \tborder: 1.5px solid var(--ion-color-primary);\n\t\t// }\n\n\t\tion-img {\n\t\t\theight: 100%;\n\t\t}\n\t}\n}\n\n.item-info {\n\tpadding: 0;\n\tpadding-right: 8px;\n\tpadding-left: 8px;\n\theight: 83%;\n\t@include desktop {\n\t\t// padding: 20px 12px;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: flex-start;\n\t}\n}\n\napp-tag {\n\tmargin-left: 3px;\n}\n\n.lines-col {\n\tpadding: 0;\n\tpadding-bottom: 5px;\n\n\t@include desktop {\n\t\theight: min-content;\n\t\tmargin-top: auto;\n\t}\n}\n\n.first-line {\n\tdisplay: block;\n\theight: 0.5px;\n\twidth: 100%;\n\tmargin: 0px 0px 0px 0px;\n\topacity: 0.5;\n\tcontent: '';\n\tbackground: #939393;\n}\n.second-line {\n\tdisplay: block;\n\theight: 1px;\n\twidth: 100%;\n\tmargin: 5px 0px;\n\tcontent: '';\n\tbackground: #939393;\n}\n.add-btn {\n\twidth: 25px;\n\theight: 25px;\n\tbackground: var(--ion-color-secondary);\n\tcolor: #ffffff;\n\tborder-radius: 5px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-size: 18px;\n\tmargin: 0px 0px 0px 5px;\n\t@include desktop {\n\t\tdisplay: none;\n\t}\n}\n\n.pfand-meirnveg {\n\tmargin: 0;\n\tfont-size: 12px;\n}\n\n.item-img {\n\tpadding: 0;\n\t@include desktop {\n\t\tdisplay: block;\n\t}\n}\n\n.image-wrapper {\n\tposition: relative;\n\t// padding: 7px 0;\n\t// height: 100%;\n\t// max-width: 100px;\n\twidth: 100%;\n\t// aspect-ratio: 90 / 80;\n\n\t@include desktop {\n\t\tpadding: 0px;\n\t\tborder-radius: 2px;\n\t}\n\n\t.main-img {\n\t\tborder-radius: 1px;\n\t\toverflow: hidden;\n\t\tobject-fit: contain;\n\t\twidth: 100%;\n\t\taspect-ratio: 4 / 3;\n\n\t\t&.default {\n\t\t\theight: 100%;\n\t\t\twidth: 85%;\n\t\t\t// padding: 20px;\n\t\t\tbackground-color: #fff;\n\t\t\t--logo-color: var(--ion-color-primary);\n\t\t}\n\t}\n}\n\n.top-selling {\n\tposition: absolute;\n\ttop: 2px;\n\tleft: 50%;\n\ttransform: translateX(-50%);\n\theight: 25px;\n\twidth: 25px;\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
